import { Component } from "preact";
import style from "./style";
import { connect } from "preact-redux";
import commonConstants from "../../utils/constants";
import {
  updateYearList,
  setCurrentYear,
} from "../../shared/actions/getYearList";
import { setMapCurrentYear } from "../../shared/actions/mapActions";
import YearSelector from "../yearSelector";
import { getDownloadCsvUrl, getLastYear, getCurrentYear } from "../../utils";

class EmbedSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: getCurrentYear(this.props.generalInfo),
    };
    this.onSelectYear = this.onSelectYear.bind(this);
  }

  onSelectYear(selectedYear) {
    this.setState({ selectedYear });
    this.props.setCurrentYear(selectedYear);
    this.props.setMapCurrentYear(selectedYear);
  }

  render() {
    return (
      <div className={style.mainWrapper}>
        {!this.props.disableDropdown ? (
          <div>
            <YearSelector
              selectedYear={
                this.props.currentYear ||
                this.state.selectedYear ||
                getLastYear()
              }
              onSelectYear={(year) => this.onSelectYear(year)}
            />
          </div>
        ) : undefined}
        {!this.props.disableEmbedExport && this.props.hideExport !== "true" ? (
          <div
            className={style.filterSectionAction}
            onClick={() =>
              window.open(
                getDownloadCsvUrl(this.props.lastUpdate.data.url),
                "_blank"
              )
            }
          >
            <i className="fas fa-download" />
            <span>Export</span>
          </div>
        ) : undefined}
        {!this.props.disableEmbedExport && this.props.hideEmbed !== "true" ? (
          <div
            style={{ display: "none" }}
            className={style.filterSectionAction}
            onClick={() => this.props.onClickEmbed && this.props.onClickEmbed()}
          >
            <i className="fas fa-code" />
            <span>Embed</span>
          </div>
        ) : undefined}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let yearList = state.yearList;
  const { currentYear } = state.yearList;
  if (
    state.tabData.tabSelected === "signature" ||
    state.breadCrumb.title === "Signature Solutions"
  ) {
    var tempArray = _.map(state.yearList.list, function (o) {
      if (o >= commonConstants.SIGNATURE_SOLUTION_YEAR) return o;
    });
    yearList.list = _.without(tempArray, undefined);
  }
  const { year } = state.projectTimeline;
  const generalInfo = state.generalInfo.data;
  return {
    lastUpdate: state.lastUpdate,
    generalInfo,
    yearList,
    year,
    currentYear,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateYearList: (year) => dispatch(updateYearList(year)),
    setCurrentYear: (year) => dispatch(setCurrentYear(year)),
    setMapCurrentYear: (year) => dispatch(setMapCurrentYear(year)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmbedSection);



// WEBPACK FOOTER //
// ./components/EmbedSection/index.js